// import { CompanyProfileBenefit } from '../types';
import CompanyBenefitsSerializers from '../serializers/CompanyBenefitsSerializers';
import CompanyProfileSerializer from '../serializers/CompanyProfileSerializers';
import { CompanyProfile, CompanyProfileBenefitEndpoint } from '../types';

import * as api from '../../../../lib/api/v1/index';
import { ApiResponse, ApiResponseError } from '../../../../lib/api/v1/types';

export class CompanyBenefitsService {
  // TODO: Decide if we need this, since we are receiving the benefits from the company.
  async getCompanyBenefits(companyId: string): Promise<ApiResponse<any>> {
    try {
      const response = await api.getCompanyBenefits(companyId);
      const body = await response.json();

      if (response.ok) {
        const companyBenefits = CompanyProfileSerializer.toObject(body);
        return {
          ok: true,
          data: companyBenefits,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  async updateCompanyBenefits(
    companyId: string,
    companyBenefits: CompanyProfile['benefits']
  ): Promise<{ benefits: CompanyProfile['benefits'] }> {
    try {
      const response = await api.updateCompanyBenefits(companyId, companyBenefits);
      if (response.ok) {
        const payload = await response.json() as CompanyProfileBenefitEndpoint;
        return CompanyBenefitsSerializers.toObject(payload);
      }
      throw new Error('Could not update company profile');
    } catch (error: unknown) {
      // catch error on sentry 
      console.error('This is the error:', error);
      throw new Error('Could not update company benefits');
    }
  }

  async createCompanyBenefits(
    companyId: string,
    companyBenefits: CompanyProfile['benefits']
  ): Promise<{ benefits: CompanyProfile['benefits'] }> {
    try {
      const response = await api.createCompanyBenefits(companyId, companyBenefits);
      if (response.ok) {
        const payload = await response.json();
        return CompanyBenefitsSerializers.toObject(payload);
      }
      throw new Error('Could not update company profile');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Failed to create benefit');
    }
  }

}

